import iconUrl from "./map_marker.svg"
import iconUrlPoi from "./map_marker_poi.svg"

const SvgPointer = [ iconUrl, iconUrlPoi ]

export default SvgPointer;